import { memo } from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

interface SortableHeaderProps {
  label: string;
  column: string;
  currentColumn: string;
  sortDirection: 'asc' | 'desc';
  onSort: (column: string) => void;
}

const SortableHeader = memo(({ label, column, currentColumn, sortDirection, onSort }: SortableHeaderProps) => {
  return (
    <th 
      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
      onClick={() => onSort(column)}
    >
      <div className="flex items-center">
        {label}
        {currentColumn === column && (
          sortDirection === 'asc' 
            ? <ArrowUp className="h-4 w-4 ml-1" /> 
            : <ArrowDown className="h-4 w-4 ml-1" />
        )}
      </div>
    </th>
  );
});

SortableHeader.displayName = 'SortableHeader';

export default SortableHeader;